import {Controller} from '@stubhub/react-store-provider';
import SessionHelper from '@stubhub/session-helper';

import {deviceTypeSelector, loginTypeSelector, subCategoriesNavSelector, multiLayeredMenuSelector} from './selectors';

const NAMESPACE = 'headerNav';

const controller = new Controller({
  namespace: NAMESPACE,
  actionCreators: {
    signOutUser,
    setActiveMenuKey,
  },
  mapStateToProps(state) {
    const deviceType = deviceTypeSelector(state);

    return {
      deviceType,
      loginType: loginTypeSelector(state),
      subCategories: subCategoriesNavSelector(state),
      webphoneEnabled: deviceType,
      multiLayeredMenu: multiLayeredMenuSelector(state),
      activeMenuKey: (state.headerNav && state.headerNav.activeMenuKey) || null,
    };
  },
  reducers: ['SET_ACTIVE_MENU_KEY'],
});

// The use of cookies, session data, and post calls here makes unit test coverage complicated to mock
/* istanbul ignore next */
function signOutUser(domain) {
  return () => {
    return SessionHelper.logout({domain});
  };
}

function setActiveMenuKey(key) {
  return (dispatch) =>
    dispatch({
      type: 'SET_ACTIVE_MENU_KEY',
      activeMenuKey: key,
    });
}

export default controller;
